export const DUPLICATE_TAG_TIMEOUT_MS = 4000;

export function tagLabel(item, itemText = 'name', itemValue = 'value') {
  if (item == null) return '';
  if (typeof item === 'object') {
    const text = item[itemText];
    const value = item[itemValue];
    if (text != null && String(text).trim() !== '') return String(text).trim();
    if (value != null && String(value).trim() !== '') return String(value).trim();
    return '';
  }
  return String(item).trim();
}

export function tagKey(item, itemText, itemValue) {
  return tagLabel(item, itemText, itemValue).toLowerCase();
}

export function trimTag(item, itemText, itemValue) {
  if (item == null) return '';
  if (typeof item === 'object') {
    const next = { ...item };
    if (next[itemText] != null) next[itemText] = String(next[itemText]).trim();
    if (next[itemValue] != null) next[itemValue] = String(next[itemValue]).trim();
    return next;
  }
  return String(item).trim();
}

/** Drop blank and case-insensitive duplicate tags. First casing wins. */
export function dedupeTags(items, itemText, itemValue) {
  const tags = [];
  const seen = new Set();
  let duplicateLabel = '';

  (items || []).forEach((item) => {
    const trimmed = trimTag(item, itemText, itemValue);
    const key = tagKey(trimmed, itemText, itemValue);
    if (!key) return;
    if (seen.has(key)) {
      duplicateLabel = tagLabel(trimmed, itemText, itemValue);
      return;
    }
    seen.add(key);
    tags.push(trimmed);
  });

  return { tags, duplicateLabel };
}

export function sameTags(left, right, itemText, itemValue) {
  const a = dedupeTags(left, itemText, itemValue).tags;
  const b = dedupeTags(right, itemText, itemValue).tags;
  if (a.length !== b.length) return false;
  return a.every((item, index) => (
    tagKey(item, itemText, itemValue) === tagKey(b[index], itemText, itemValue)
  ));
}

export function findTag(items, query, itemText, itemValue) {
  const key = String(query || '').trim().toLowerCase();
  if (!key) return null;
  return (items || []).find((item) => tagKey(item, itemText, itemValue) === key) || null;
}
